import { UtmTrackingAttr } from 'signup-constants/UtmTrackingAttr';
const expUtms = {};
Object.values(UtmTrackingAttr).forEach(utmKey => {
  // looks like `exp-campaign`
  const expKey = utmKey.replace('utm_', 'exp-');
  expUtms[expKey] = utmKey;
});
export default expUtms;